// extracted by mini-css-extract-plugin
export var active = "_fq-7";
export var blink = "_fq-8";
export var dropDownSelector = "_fq-4";
export var dropDownWrapper = "_fq-3";
export var fakeCursor = "_fq-6";
export var fontSizeButton = "_fq-9";
export var formQuillEditor = "_fq-0";
export var pressed = "_fq-a";
export var qlBlank = "_fq-1";
export var textFormattingToolbar = "_fq-2";
export var textToolbarOption = "_fq-5";